<template>
  <div
    :class="{ marginView: getEditor.marginView, marginsTotal: true }"
    :style="[getMarginViewStyle]"
  >
    <div
      v-if="(getMargin.top || getMargin.bottom) && !getFormat.rounded"
      class="formatInfo formatMarginL"
    >
      {{ getMargin.top + getMargin.bottom + getFormat.height }} {{ $t("cm") }}
    </div>
    <div
      v-if="getMargin.left || getMargin.right"
      class="formatInfo formatMarginT"
    >
      {{ getMargin.left + getMargin.right + getFormat.width }} {{ $t("cm") }}
    </div>
  </div>
</template>
<script>
import { useImageEditorStore } from "@/stores/modules/imageEditor";
import { useEditorFilesStore } from "@/stores/modules/editorFiles";
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    ...mapState(useImageEditorStore, [
      "getFormat",
      "getMargin",
      "getEditor",
      "canvasFormatLeft",
      "canvasFormatDimByFormat"
    ]),
    totalWidth: function () {
      return this.getMargin.left + this.getMargin.right + this.getFormat.width;
    },
    totalHeight: function () {
      return this.getMargin.left + this.getMargin.right + this.getFormat.width;
    },
    getMarginViewStyle: function () {
      var size = this.canvasFormatDimByFormat;
      var corrections = this.getCorrections();
      var result = {
        width: Math.round(size.width) + "px",
        height: Math.round(size.height) + "px",
        top: Math.round(size.top + corrections.top) + "px",
        left: Math.round(size.left + corrections.left) + "px"
      };

      return result;
    }
  },
  methods: {
    getCorrections: function () {
      return {
        left: this.canvasFormatLeft,
        top: this.getEditor.dim.canvasDimByFormat.top
      };
    }
  }
};
</script>
